package com.swetdot.swetgram.protocol.dto

import com.swetdot.swetgram.protocol.Timestamp
import com.swetdot.swetgram.protocol.Uuid
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class SquadStreakType {
    @SerialName("duo") DUO,
    @SerialName("group") GROUP,
    @SerialName("unknown") UNKNOWN,
}

@Serializable
data class SquadStreakParticipant(
    @SerialName("user_id") val userId: Uuid,
    @SerialName("steps_count") val stepsCount: Int,
    @SerialName("messages_sent") val messagesSent: Int,
    @SerialName("target_met") val targetMet: Boolean,
)

@Serializable
data class SquadStreak(
    @SerialName("id") val id: Uuid,
    @SerialName("conversation_id") val conversationId: Uuid,
    @SerialName("type") val type: SquadStreakType = SquadStreakType.UNKNOWN,
    @SerialName("current_streak") val currentStreak: Int,
    @SerialName("longest_streak") val longestStreak: Int,
    @SerialName("today_target_met") val todayTargetMet: Boolean,
    @SerialName("participants") val participants: List<SquadStreakParticipant> = emptyList(),
    @SerialName("updated_at") val updatedAt: Timestamp,
)

@Serializable
data class StartSquadStreakRequest(
    @SerialName("client_id") val clientId: Uuid,
    @SerialName("conversation_id") val conversationId: Uuid,
)

@Serializable
data class NudgeSquadStreakResponse(
    @SerialName("notified") val notified: Boolean,
    @SerialName("message") val message: String,
)
